import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../shared/_services/validation.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePassword: any = FormGroup;
  addUser: any = FormGroup;
  public loading = false;
  loginUserInfo: any;
  userData: any;
  error: boolean = false;
  success: boolean = false;
  errorMessage: String = "";
  successMessage: String = "";
  mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  public modalRef: BsModalRef;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "changePwdModal"
  };

  constructor(private fb: FormBuilder, private http: AuthService, private router: Router, private modalService: BsModalService, private validation: ValidationService) { }

  getProfileData(userId) {
    this.http.getUserDataApi(userId).subscribe(res => {
      // this.userData = res.responseObj;
      this.initForm(res.responseObj);
    },
      error => {
        console.log(error);
      });
  }

  UpdateUser(modalData){
    //console.log(this.addUser.value);
    this.http.updateUserApi(this.addUser.value).subscribe(
      res=>{
        this.loading = false;
        if(res.error === 0){
          this.error = false;
          this.success = true;
          this.errorMessage = "";
          this.successMessage = res.message;
          this.modalRef = this.modalService.show(modalData, this.config);          
        }else{
          this.success = false;
          this.error = true;
          this.successMessage = "";
          this.errorMessage = res.message;
          this.modalRef = this.modalService.show(modalData, this.config);          
          //console.log(this.errorMessage);
        }
      },
      error=>{
        this.loading = false;
        this.success = false;
        this.error = true;
        this.successMessage = "";
        this.errorMessage = error.message ? error.message : 'Failed, Please try again';
        // this.errorMessage = "Exception occured. Please try again";
        this.modalRef = this.modalService.show(modalData, this.config);          
        //console.log(this.errorMessage);
      }
    )
  }

  initForm(data) {
    //console.log(data);
    this.addUser = this.fb.group({
      userId: [data && data.userId ? data.userId : '' ],
      firstName: [data && data.firstName ? data.firstName : '', Validators.compose([Validators.minLength(1), Validators.required])],
      lastName: [data && data.lastName ? data.lastName : '', Validators.compose([Validators.minLength(1), Validators.required])],
      email: [data && data.email ? data.email : '', [Validators.required, , Validators.pattern(this.validation.email_regexPattern)]],
      phoneNumber: [data && data.phoneNumber ? data.phoneNumber : '', [Validators.maxLength(10), Validators.pattern(this.mobnumPattern)]]
    });
  }

  ngOnInit() {
    this.initForm(null);
    if(JSON.parse(localStorage.getItem('currentUser'))){
      this.loginUserInfo = JSON.parse(localStorage.getItem('currentUser'));
    }else{
      this.loginUserInfo = JSON.parse(localStorage.getItem('autoLoginUserObj'));
    }


    //console.log(this.loginUserInfo.userId);
    if (this.loginUserInfo.userId) {
      this.getProfileData(this.loginUserInfo.userId);
    }
    this.changePassword = this.fb.group({
      oldPwd: ['', [Validators.required]],
      newPwd: ['', [Validators.minLength(8), Validators.maxLength(15), Validators.required, Validators.pattern(this.validation.password_Pattern)]]
    });
  }

  public noWhitespaceValidator(control: FormControl) {
    //console.log(control);
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }

  //saving new password
  save(changePwdObj, modalData) {
    this.http.changePwdApi(changePwdObj).subscribe(
      res => {
        this.loading = false;
        if (res.error === 0) {
          this.modalRef = this.modalService.show(modalData, this.config);
          this.error = false;
          this.success = true;
          this.errorMessage = "";
          this.successMessage = res.message;
          this.changePassword.reset();
          localStorage.removeItem('token');
          localStorage.clear();
        } else {
          this.modalRef = this.modalService.show(modalData, this.config);
          this.success = false;
          this.error = true;
          this.successMessage = "";
          this.errorMessage = res.message;
          //console.log(this.errorMessage);
        }
      },
      error => {
        this.modalRef = this.modalService.show(modalData, this.config);
        this.loading = false;
        this.success = false;
        this.error = true;
        this.successMessage = "";
        this.errorMessage = "Please try again";
        //console.log(this.errorMessage);
      }
    )
  }

  //redirecting to login page
  login() {
    this.modalRef.hide();
  }

  logout(){
    this.modalRef.hide();
    localStorage.removeItem('token');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  //closing modal
  ok() {
    this.modalRef.hide();
  }

  goBack() {
    window.history.back();
  }


}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.component.ts